/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';

import { Fade } from 'react-awesome-reveal';

import Button from '../elements/Button';

export default function Discuss() {
  return (
    <section className="py-20">
      <div className="container mx-auto px-4">
        <Fade direction="up" triggerOnce>
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-theme-purple via-dark-theme-purple to-theme-blue p-12 md:p-16 lg:p-20">
            {/* Background decoration */}
            <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-theme-purple/30 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />

            <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-10">
              {/* Left content */}
              <div className="lg:w-2/3 text-center lg:text-left">
                <p className="text-light-theme-purple text-sm font-medium uppercase tracking-wider mb-4">
                  Ready to Partner?
                </p>
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
                  Let&apos;s Build Something
                  <br />
                  <span className="text-yellow-300">Amazing Together</span>
                </h2>
                <p className="text-lg text-gray-200 max-w-xl">
                  Whether you&apos;re looking to publish your app, need development expertise,
                  or want to explore partnership opportunities - we&apos;re here to help.
                </p>
              </div>

              {/* Right CTA buttons */}
              <div className="flex flex-col sm:flex-row lg:flex-col gap-4">
                <Fade direction="up" delay={200} triggerOnce>
                  <Button
                    isExternal
                    href="/#partner"
                    type="link"
                    className="flex items-center justify-center px-8 py-5 bg-white text-theme-purple font-semibold text-lg rounded-xl shadow-xl hover:bg-yellow-300 hover:text-theme-blue transition-all duration-300 cursor-pointer group"
                  >
                    Start Partnership
                    <svg className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Button>
                </Fade>
                <Fade direction="up" delay={400} triggerOnce>
                  <Button
                    href="/project"
                    type="link"
                    className="flex items-center justify-center px-8 py-5 bg-transparent text-white font-semibold text-lg rounded-xl border-2 border-white/30 hover:bg-white/10 hover:border-white/50 transition-all duration-300 cursor-pointer"
                  >
                    View Our Portfolio
                  </Button>
                </Fade>
              </div>
            </div>

            {/* Trust indicators */}
            <Fade direction="up" delay={600} triggerOnce>
              <div className="relative z-10 mt-12 pt-8 border-t border-white/10">
                <div className="flex flex-wrap justify-center lg:justify-start gap-8 text-center lg:text-left">
                  <div>
                    <p className="text-2xl font-bold text-white">24hr</p>
                    <p className="text-sm text-gray-300">Response Time</p>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-white">100%</p>
                    <p className="text-sm text-gray-300">Partner Satisfaction</p>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-white">NDA</p>
                    <p className="text-sm text-gray-300">Protected</p>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-white">Global</p>
                    <p className="text-sm text-gray-300">Partnership</p>
                  </div>
                </div>
              </div>
            </Fade>
          </div>
        </Fade>
      </div>
    </section>
  );
}
